// src/modals/ProfileModal.js
import React from "react";
import { Colors } from "../constants/Colors";

const ProfileModal = ({ show, onClose, user, isSettings }) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1060,
      }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "12px",
            border: `1px solid ${Colors.LIGHT_GRAY}`,
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
            backgroundColor: Colors.WHITE,
          }}
        >
          <div
            className="modal-header"
            style={{
              borderBottom: `1px solid ${Colors.LIGHT_GRAY}`,
              background: `linear-gradient(90deg, ${Colors.GRADIENT_START}, ${Colors.GRADIENT_END})`,
            }}
          >
            <h5
              className="modal-title fw-bold text-white"
              style={{ fontSize: "1.25rem" }}
            >
              {isSettings ? "Account Settings" : "User Profile"}
            </h5>
            <button
              type="button"
              className="btn-close"
              style={{ filter: "brightness(0) invert(1)" }}
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body p-4">
            {isSettings ? (
              <div>
                <div className="mb-4">
                  <h6
                    className="fw-semibold mb-3"
                    style={{ color: Colors.TEXT_DARK }}
                  >
                    Personal Information
                  </h6>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label fw-medium"
                        style={{ color: Colors.TEXT_DARK }}
                      >
                        New Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter new password"
                        style={{
                          borderColor: Colors.LIGHT_GRAY,
                          borderRadius: "8px",
                        }}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label fw-medium"
                        style={{ color: Colors.TEXT_DARK }}
                      >
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm new password"
                        style={{
                          borderColor: Colors.LIGHT_GRAY,
                          borderRadius: "8px",
                        }}
                        required
                      />
                    </div>
                  </div>
                  {false && (
                    <div className="text-danger small mt-1">
                      Passwords do not match.
                    </div>
                  )}
                </div>
                <div className="mb-4">
                  <h6
                    className="fw-semibold mb-3"
                    style={{ color: Colors.TEXT_DARK }}
                  >
                    Notification Preferences
                  </h6>
                  <select
                    className="form-select"
                    style={{
                      borderColor: Colors.LIGHT_GRAY,
                      borderRadius: "8px",
                      padding: "0.75rem",
                    }}
                  >
                    <option>All Notifications</option>
                    <option>Only Important</option>
                    <option>None</option>
                  </select>
                </div>
                <button
                  className="btn btn-primary w-100 py-2"
                  style={{
                    backgroundColor: Colors.PRIMARY,
                    borderRadius: "8px",
                    fontWeight: "500",
                  }}
                  disabled={false}
                >
                  {false ? "Saving..." : "Save Changes"}
                </button>
              </div>
            ) : (
              <div>
                <div className="text-center mb-4">
                  <img
                    src="https://via.placeholder.com/100x100"
                    alt="Profile"
                    className="rounded-circle"
                    style={{
                      border: `3px solid ${Colors.PRIMARY}`,
                      width: "100px",
                      height: "100px",
                    }}
                  />
                  <h5
                    className="mt-3 fw-bold"
                    style={{ color: Colors.TEXT_DARK }}
                  >
                    {user.name}
                  </h5>
                  <p style={{ color: Colors.TEXT_LIGHT }}>
                    {user.role} | Joined: {user.joined}
                  </p>
                </div>
                <div className="row g-3">
                  <div className="col-12">
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: Colors.LIGHT_GRAY,
                        borderRadius: "8px",
                      }}
                    >
                      <p>
                        <strong style={{ color: Colors.TEXT_DARK }}>
                          Email:
                        </strong>{" "}
                        <span style={{ color: Colors.TEXT_LIGHT }}>
                          {user.email}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: Colors.LIGHT_GRAY,
                        borderRadius: "8px",
                      }}
                    >
                      <p>
                        <strong style={{ color: Colors.TEXT_DARK }}>
                          Last Login:
                        </strong>{" "}
                        <span style={{ color: Colors.TEXT_LIGHT }}>
                          {new Date().toLocaleString("en-US", {
                            timeZone: "PST",
                            hour12: true,
                          })}{" "}
                          {/* 12:48 PM PST, July 02, 2025 */}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
